"use client"

import * as React from "react"
import { LuMoon, LuSun } from "react-icons/lu"

import { ThemeProvider, useTheme } from "../theme-provider"

export interface ColorModeProviderProps extends React.ComponentProps<typeof ThemeProvider> {
  children: React.ReactNode
}

export function ColorModeProvider(props: ColorModeProviderProps) {
  return (
    <ThemeProvider {...props} />
  )
}

export type ColorMode = "light" | "dark"

export interface UseColorModeReturn {
  colorMode: ColorMode
  setColorMode: (colorMode: ColorMode) => void
  toggleColorMode: () => void
}

export function useColorMode(): UseColorModeReturn {
  const { theme, setTheme } = useTheme()
  const toggleColorMode = () => {
    setTheme(theme === "dark" ? "dark" : "light")
  }
  return {
    colorMode: theme as ColorMode,
    setColorMode: setTheme,
    toggleColorMode,
  }
}

export function useColorModeValue<T>(light: T, dark: T) {
  const { colorMode } = useColorMode()
  return colorMode === "dark" ? dark : light
}

export function ColorModeIcon() {
  const { colorMode } = useColorMode()
  return colorMode === "dark" ? <LuMoon /> : <LuSun />
}
